import React, { useEffect } from "react";
import { useSearchParams } from "react-router-dom";

/**
 * Bridge for Converse Agent mobile WebView.
 * /mobile-auth?token=JWT&refresh=...&user={json}&redirect=/dashboard/settings
 */
export default function MobileAuthPage() {
  const [params] = useSearchParams();

  useEffect(() => {
    const token = params.get("token")?.trim();
    const redirect = params.get("redirect")?.trim() || "/dashboard";
    const refresh = params.get("refresh")?.trim();
    const userRaw = params.get("user")?.trim();

    if (!token) {
      window.location.replace("/login");
      return;
    }

    try {
      localStorage.setItem("token", token);
      if (refresh) localStorage.setItem("refreshToken", refresh);
      if (userRaw) localStorage.setItem("user", userRaw);
    } catch {
      /* storage blocked */
    }

    const target = redirect.startsWith("/") ? redirect : `/${redirect}`;
    window.location.replace(target);
  }, [params]);

  return (
    <div style={{ padding: 24, fontFamily: "system-ui, sans-serif", color: "#334155" }}>
      Opening admin panel…
    </div>
  );
}
